import types from '../../constants';

const initialState = {
  loading: false,
  data: [],
};

const CompaniesReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.COMPANIES_FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case types.COMPANIES_FETCH_END:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case types.COMPANIES_FETCH_FAILED:
      return {
        ...state,
        loading: false,
      };
    case types.COMPANIES_CHANGE_FILTER:
      const newFilter = { ...state.filter };
      const { key, value } = action.payload;
      newFilter[key] = value;

      return {
        ...state,
        filter: newFilter,
      };
    case types.COMPANIES_RESET_FILTER:
      return {
        ...state,
        filter: {},
      };
    default:
      return state;
  }
};

export default CompaniesReducers;
